import { render } from "./delayTimeModal.vue?vue&type=template&id=e06f29c4&scoped=true"
import script from "./delayTimeModal.vue?vue&type=script&lang=js"
export * from "./delayTimeModal.vue?vue&type=script&lang=js"

import "./delayTimeModal.vue?vue&type=style&index=0&id=e06f29c4&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06f29c4"]])

export default __exports__